import React from 'react';
import axios from 'axios';
import type { Project } from 'bundles/client_reports/client_report_types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faClockRotateLeft } from '@fortawesome/pro-solid-svg-icons';

interface Props {
  project: Project;
}

const ClientReportFooter: React.FC<Props> = ({ project }: Props) => {
  if (!project) return null;

  const handleToggle = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    try {
      await axios.post(`/projects/${project.id}/client_report/toggle_updated_client_report`);
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const isUpdated = !!project.updatedClientReport;
  const bannerClass = [
    'client-report-footer',
    'py-3',
    isUpdated ? 'updated-client-report-banner' : 'old-client-report-banner'
  ].join(' ');

  return (
    <div className={bannerClass}>
      {isUpdated ? (
        <span>
          <FontAwesomeIcon className="mr-3" icon={faClockRotateLeft} />
          New Client Report not what you were expecting?{' '}
          <a href="#" style={{ color: '#924FDC' }} onClick={handleToggle}>Revert to the Legacy Client Report</a>
        </span>
      ) : (
        <span>
          <FontAwesomeIcon className="mr-3" icon={faCircleInfo} />
          You're using the Legacy Client Report. The New Client Report experience is available{' '}
          <a href="#" style={{ color: '#924FDC' }} onClick={handleToggle}>here</a>.
        </span>
      )}
    </div>
  );
};

export default ClientReportFooter;
